export default function restaurant() {
  return [
    'blogPost',
    'blogList',
    'blogFeed',
    'blogGrid',
  ];
}



// WEBPACK FOOTER //
// ./src/global-view/editor/page/droplets-tab/site-types/blog.js